module.exports = __webpack_public_path__ + "static/refract-bg_3-518357e0e23c618d348b0c41f986c2a7.mp4";